import { useParams } from "react-router-dom";
import "../../../scss/common.scss";
import { useAccountQuicksight } from "../../../hooks/quicksight/useAccountQuicksight.ts";
import { IFrame } from "core/components/iframe/index.ts";

/**
 * Integrated QuickSight dashboard only (no adhoc context_id).
 */
export function AccountIntegratedDashboardPage() {
  const { id } = useParams();
  const result = useAccountQuicksight({ account_number: id! });
  return <IFrame.Query query={result} />;
}
